import { type ReactNode } from 'react';
import { Form } from '@belong/ui';

type Props = {
  isDisabled: boolean;
  children: ReactNode;
};

export function ApprovalFormSubmitButton({ isDisabled, children }: Props) {
  return (
    <>
      <div className="my-2xl w-full md:hidden">
        <Form.SubmitButton type="submit" disabled={isDisabled}>
          {children}
        </Form.SubmitButton>
      </div>
      <div className="hidden md:flex md:justify-center">
        <Form.SubmitButton type="submit" size="large" disabled={isDisabled}>
          {children}
        </Form.SubmitButton>
      </div>
    </>
  );
}
